import React from 'react';
// import * as yup from 'yup';
import { format } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Info from '@material-ui/icons/InfoOutlined';
import Input from '../Input/Input';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import AddIcon from '@material-ui/icons/Add';
import DeleteIcon from '@material-ui/icons/Delete';

import DataTable from '../DataTable/DataTable';
import ShiftForm from './ShiftsForm';
import { TimerSharp } from '@material-ui/icons';
import { event } from 'react-ga';
import { Settings } from '@material-ui/icons';
import { IconButton, Modal, Typography } from '@material-ui/core';


const styles = theme => ({
  button: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  days: {
    padding: `${theme.spacing(5)}px 0`,
  },
  hint: {
    top: '46px',
    left: '5px',
    position: 'relative',
  },
});

const initialFormState = {
  days: [
    { value: 'SEG', label: 'Segunda', checked: false },
    { value: 'TER', label: 'Terça', checked: false },
    { value: 'QUA', label: 'Quarta', checked: false },
    { value: 'QUI', label: 'Quinta', checked: false },
    { value: 'SEX', label: 'Sexta', checked: false },
    { value: 'SAB', label: 'Sábado', checked: false },
    { value: 'DOM', label: 'Domingo', checked: false },
  ],
  shiftsTurns: {
    firstShiftIni: null,
    firstShiftEnd: null,
    secondShiftIni: null,
    secondShiftEnd: null,
    timeForDays: null,
    maxAccumulatedPositiveTolerance: null,
    maxCreditToBankOfHours: null,
    specialHoursAfterMinutes: null,
    daysOffAndHolidaysFactor: null
  },
};

// const shiftSchema = yup.object().shape({
//   firstShiftIni: yup.string().matches(/\d\d:\d\d/),
//   firstShiftEnd: yup.string().matches(/\d\d:\d\d/),
//   secondShiftIni: yup.string().matches(/(\d\d:\d\d)?/),
//   secondShiftEnd: yup.string().matches(/(\d\d:\d\d)?/),
// });

class WeekdayForm extends React.Component {
  state = {
    openModal: false,
    currentAction: null,
    currentItem: null,
    ...initialFormState,
    initialTurn: null,
    emptTurn: null,
    maximumHours: null,
    shift: {},
    openModalBankHours: false,
    tolerance: false,
    isToConsiderClockInDelay: false,
    considerNightHoursCorrectedInBankHour: false,
    hasBankHourLimit: false,
    specialHoursSundayAndHoliday: false,
    considerRemainingHoursToBankHoursAndExtraHours: false,
    isToFollowNormally: false,
    specialExtraHoursInBankHours: false,
    clockInNegativeTolerance: null,
    clockInPositiveTolerance: null,
    clockOutNegativeTolerance: null,
    clockOutPositiveTolerance: null,
    clockInNegativeToleranceSecond: null,
    clockInPositiveToleranceSecond: null,
    clockOutNegativeToleranceSecond: null,
    clockOutPositiveToleranceSecond: null,
    intervalNegativeTolerance: null,
    intervalPositiveTolerance: null,
    disabledButton: true,
    flexScaleHours: false
  };



  resetFormState = () => {
    this.setState({ ...initialFormState });
  };

  resetTolerance = () => {
    this.setState({ clockInNegativeTolerance: null, clockInPositiveTolerance: null, clockOutNegativeTolerance: null, clockOutPositiveTolerance: null, intervalPositiveTolerance: null, intervalNegativeTolerance: null })
    this.closeToleranceModal()
  }


  handleChangeInput(event, fieldName) {
    // Verificar se o componente ainda está montado antes de atualizar o estado
    this.setState({ [fieldName]: event });

    const disabled = this.state.clockInNegativeTolerance !== null && this.state.clockInPositiveTolerance !== null && this.state.clockOutNegativeTolerance !== null && this.state.clockOutPositiveTolerance !== null;

    if (!!disabled) {
      this.setState({ disabledButton: false })
    } else {
      this.setState({ disabledButton: true })
    }
  }

  handleWeekdaysChange = index => (event) => {
    const { days } = this.state;
    const newDays = [...days];
    newDays[index] = { ...days[index], checked: event.target.checked };

    this.setState({ days: newDays });
  };

  handleInputChange = name => (event) => {
    if (event && event.target) {
      this.setState({ shiftsTurns: { ...this.state.shiftsTurns, [name]: event.target.value } });
    } else {
      this.setState({ shiftsTurns: { ...this.state.shiftsTurns, [name]: event } });
    }
  };

  handleCloseModal = () => {
    this.setState({ openModalBankHours: false })
  }

  handleMaximumHours = (hours) => {
    this.setState({ maximumHours: hours })
  }

  handleOpen = (action, id) => {
    this.setState({ openModal: true, currentAction: action, currentItem: id });
  };

  handleIsTolerance(event) {
    const isChecked = event.target.checked;
    this.setState({ tolerance: isChecked });
    // fazer outras ações com o isChecked, se necessário
  }

  closeToleranceModal = () => {
    this.setState({ tolerance: false })
  }


  handleClose = () => {
    this.setState({ openModal: false });
  };

  handleConfirm = () => {
    const {
      currentAction, days, shiftsTurns, currentItem,
    } = this.state;

    const isZeroScale = this.props.values.isZeroScale
    const date = new Date();
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);

    if (currentAction === 'Cadastrar') {
      const toleranceInOut = {
        clockInNegativeTolerance: this.state.clockInNegativeTolerance !== null ? new Date(this.state.clockInNegativeTolerance).getMinutes() : null,
        clockInPositiveTolerance: this.state.clockInPositiveTolerance !== null ? new Date(this.state.clockInPositiveTolerance).getMinutes() : null,
        clockOutNegativeTolerance: this.state.clockOutNegativeTolerance !== null ? new Date(this.state.clockOutNegativeTolerance).getMinutes() : null,
        clockOutPositiveTolerance: this.state.clockOutPositiveTolerance !== null ? new Date(this.state.clockOutPositiveTolerance).getMinutes() : null,
        clockInNegativeToleranceSecond: this.state.clockInNegativeToleranceSecond !== null ? new Date(this.state.clockInNegativeToleranceSecond).getMinutes() : null,
        clockInPositiveToleranceSecond: this.state.clockInPositiveToleranceSecond !== null ? new Date(this.state.clockInPositiveToleranceSecond).getMinutes() : null,
        clockOutNegativeToleranceSecond: this.state.clockOutNegativeToleranceSecond !== null ? new Date(this.state.clockOutNegativeToleranceSecond).getMinutes() : null,
        clockOutPositiveToleranceSecond: this.state.clockOutPositiveToleranceSecond !== null ? new Date(this.state.clockOutPositiveToleranceSecond).getMinutes() : null,
        intervalPositiveTolerance: this.state.intervalPositiveTolerance !== null ? new Date(this.state.intervalPositiveTolerance).getMinutes() : null,
        intervalNegativeTolerance: this.state.intervalNegativeTolerance !== null ? new Date(this.state.intervalNegativeTolerance).getMinutes() : null,
        maxAccumulatedPositiveTolerance: shiftsTurns.maxAccumulatedPositiveTolerance !== null ? new Date(shiftsTurns.maxAccumulatedPositiveTolerance).getHours() * 60 + new Date(shiftsTurns.maxAccumulatedPositiveTolerance).getMinutes() : null,
        maxCreditToBankOfHours: shiftsTurns.maxCreditToBankOfHours !== null ? new Date(shiftsTurns.maxCreditToBankOfHours).getHours() * 60 + new Date(shiftsTurns.maxCreditToBankOfHours).getMinutes() : null,
        specialHoursAfterMinutes: shiftsTurns.specialHoursAfterMinutes !== null ? new Date(shiftsTurns.specialHoursAfterMinutes).getHours() * 60 + new Date(shiftsTurns.specialHoursAfterMinutes).getMinutes() : null,
        daysOffAndHolidaysFactor: shiftsTurns.daysOffAndHolidaysFactor
      }

      const shift = {
        days: days.reduce((newDays, day) => {
          if (day.checked) {
            newDays.push(day.value);
          }
          return newDays;
        }, []),
        shiftsTurns: {
          firstShiftIni: isZeroScale ? format(date, 'HH:mm') : format(shiftsTurns.firstShiftIni, 'HH:mm'),
          firstShiftEnd: isZeroScale ? format(date, 'HH:mm') : format(shiftsTurns.firstShiftEnd, 'HH:mm'),
          secondShiftIni: shiftsTurns.secondShiftIni
            ? format(shiftsTurns.secondShiftIni, 'HH:mm')
            : null,
          secondShiftEnd: shiftsTurns.secondShiftEnd
            ? format(shiftsTurns.secondShiftEnd, 'HH:mm')
            : null,
        },
        explicitExpectedWorkInMinutes: shiftsTurns.timeForDays ? format(shiftsTurns.timeForDays, 'HH:mm') : null,
        considerOnlyWorkingMinutes: isZeroScale,
        clockInNegativeTolerance: toleranceInOut.clockInNegativeTolerance ? toleranceInOut.clockInNegativeTolerance : null,
        clockInPositiveTolerance: toleranceInOut.clockInPositiveTolerance ? toleranceInOut.clockInPositiveTolerance : null,
        clockOutNegativeTolerance: toleranceInOut.clockOutNegativeTolerance ? toleranceInOut.clockOutNegativeTolerance : null,
        clockOutPositiveTolerance: toleranceInOut.clockOutPositiveTolerance ? toleranceInOut.clockOutPositiveTolerance : null,
        secondShiftsTolerance: {
          clockInNegativeTolerance: toleranceInOut.clockInNegativeToleranceSecond ? toleranceInOut.clockInNegativeToleranceSecond : null,
          clockInPositiveTolerance: toleranceInOut.clockInPositiveToleranceSecond ? toleranceInOut.clockInPositiveToleranceSecond : null,
          clockOutNegativeTolerance: toleranceInOut.clockOutNegativeToleranceSecond ? toleranceInOut.clockOutNegativeToleranceSecond : null,
          clockOutPositiveTolerance: toleranceInOut.clockOutPositiveToleranceSecond ? toleranceInOut.clockOutPositiveToleranceSecond : null,
        },
        intervalPositiveTolerance: toleranceInOut.intervalPositiveTolerance,
        intervalNegativeTolerance: toleranceInOut.intervalNegativeTolerance,
        isToConsiderClockInDelay: this.state.isToConsiderClockInDelay,
        flexScaleHours: this.state.flexScaleHours,
        considerNightHoursCorrectedInBankHour: this.state.considerNightHoursCorrectedInBankHour,
        hasBankHourLimit: this.state.hasBankHourLimit,
        specialHoursSundayAndHoliday: this.state.specialHoursSundayAndHoliday,
        maxAccumulatedPositiveTolerance: toleranceInOut.maxAccumulatedPositiveTolerance ? toleranceInOut.maxAccumulatedPositiveTolerance : null,
        maxCreditToBankOfHours: toleranceInOut.maxCreditToBankOfHours ? toleranceInOut.maxCreditToBankOfHours : null,
        specialHoursAfterMinutes: toleranceInOut.specialHoursAfterMinutes ? toleranceInOut.specialHoursAfterMinutes : null,
        daysOffAndHolidaysFactor: toleranceInOut.daysOffAndHolidaysFactor == null ? null : toleranceInOut.daysOffAndHolidaysFactor,
        considerRemainingHoursToBankHoursAndExtraHours: this.state.considerRemainingHoursToBankHoursAndExtraHours,
        holidaysConfig: {
          isToFollowNormally: this.state.isToFollowNormally,
          specialExtraHoursInBankHours: this.state.specialExtraHoursInBankHours
        }
      };
      this.setState({ shift: shift })
      this.props.handleAddShift(shift);
    } else {
      this.props.handleDeleteShift(currentItem);
    }
    this.handleClose();
    this.resetFormState();
  };

  isDisabled = () => {
    const { days, shiftsTurns } = this.state;
    let count = 0;
    if (!shiftsTurns.firstShiftIni && !shiftsTurns.firstShiftEnd) {
      return true
    } else {
      return false
    }

    // Object.entries(shiftsTurns).forEach(([key, value]) => {
    //   if (value) {
    //     count += 1;
    //   }
    // });

    // for (let index = 0; index < days.length; index++) {
    //   if (days[index].checked) {
    //     if (!shiftsTurns.firstShiftIni || !shiftsTurns.firstShiftEnd) {
    //       return true;
    //     }
    //     if (count !== 0 && count % 2 === 0) {
    //       return false;
    //     }
    //     return true;
    //   }
    // }
    // return true;
  };

  render() {
    const { classes, shifts, closeTour, values, handleChange, handleAddShift } = this.props;
    const {
      openModal, currentAction, days, shiftsTurns, tolerance
    } = this.state;
    console.log('tolerance', this.state.tolerance)
    const columns = [
      { name: 'days', label: 'Dias' },
      { name: 'firstShiftIni', label: 'Início Turno 1' },
      { name: 'firstShiftEnd', label: 'Término Turno 1' },
      { name: 'secondShiftIni', label: 'Início Turno 2' },
      { name: 'secondShiftEnd', label: 'Término Turno 2' },
    ];
    const maxAccumulatedPositiveTolerance = [
      // {
      //   elementType: 'input',
      //   config: {
      //     name: 'daysOffAndHolidaysFactor',
      //     label: 'multiplicação de excedentes',
      //     required: false,
      //   }
      // },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'maxAccumulatedPositiveTolerance',
          label: 'Atraso máximo permitido do dia',
          required: false,
        }
      },
      {
        elementType: 'timePicker',
        config: {
          name: 'maxCreditToBankOfHours',
          label: 'Crédito máximo banco de horas',
          required: false,
        },
      },
      {
        elementType: 'timePicker',
        config: {
          name: 'specialHoursAfterMinutes',
          label: 'Horas extras especiais após horário definido',
          required: false,
        },
      }
    ]

    const toleranceConfig = [
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockInNegativeTolerance',
          label: 'Tolerância negativa entrada 1° turno',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockInPositiveTolerance',
          label: 'Tolerância positiva entrada 1° turno',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockOutNegativeTolerance',
          label: 'Tolerância negativa saída 1° turno',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockOutPositiveTolerance',
          label: 'Tolerância positiva saída 1° turno',
          required: false,
        }
      },
    ]

    const toleranceConfigSecondTurn = [
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockInNegativeToleranceSecond',
          label: 'Tolerância negativa entrada 2° turno',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockInPositiveToleranceSecond',
          label: 'Tolerância positiva entrada 2° turno',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockOutNegativeToleranceSecond',
          label: 'Tolerância negativa saída 2° turno',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'clockOutPositiveToleranceSecond',
          label: 'Tolerância positiva saída 2° turno',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'intervalPositiveTolerance',
          label: 'Tolerância positiva de intervalo',
          required: false,
        }
      },
      {
        elementType: 'minuteTimePicker',
        config: {
          name: 'intervalNegativeTolerance',
          label: 'Tolerância negativa de intervalo',
          required: false,
        }
      },
    ]


    const actions = [
      {
        name: 'Excluir',
        icon: DeleteIcon,
        onClick: item => this.handleOpen('Excluir', item.id),
      },
    ];

    const userIdSuporte = JSON.parse(localStorage.getItem('companies'))[0].userId

    const suportSchudeleConfig = userIdSuporte == 33920 || userIdSuporte == 2005 || userIdSuporte == 35802 || userIdSuporte == 50639 || userIdSuporte == 53230 || userIdSuporte == 58886 || userIdSuporte == 63485 || userIdSuporte == 74697 || userIdSuporte == 75892 || userIdSuporte == 77251


    return (
      <React.Fragment>
        {closeTour}
        <div className={classes.button}>
          <Button variant="contained" color="primary" onClick={() => this.handleOpen('Cadastrar')}
            data-tut="reactour__cadastrar"
          >
            <AddIcon /> Cadastrar
          </Button>
        </div>

        <DataTable
          rows={shifts.map((shift, index) => ({
            ...shift.shiftsTurns,
            days: shift.days.join(' '),
            id: index,
          }))}
          columns={columns}
          actions={actions}
        />
        {/* <Input
          elementType='timePicker'
          data-tut="reactour__descrever"
          name="horaryClosing"
          label="Término do dia:"
          value={values.horaryClosing}
          onChange={event => handleChange(event, 'horaryClosing')}
          style={{ minWidth: '35%', marginTop: '25px' }}
        /> */}
        {/* <Tooltip title="Jornadas iniciadas antes deste horário serão consideradas pertencentes ao dia anterior. Para ter aderência as regras da CLT sugerimos que esse horário seja pelo menos 11h depois do término do último turno." >
          <span className={classes.hint}> <Info color="primary" /> </span>
        </Tooltip> */}

        <Dialog open={openModal} onClose={this.handleClose} maxWidth={false}>
          <DialogTitle>{currentAction} turno</DialogTitle>
          <DialogContent>
            <DialogContentText>
              {currentAction === 'Cadastrar'
                ? 'Informe os dados para o cadastro de um turno'
                : 'Você tem certeza que deseja efetuar esta ação?'}
            </DialogContentText>
            {this.props.values.isZeroScale ? 'Escala Flexível' : ''}
            {
              this.props.values.isZeroScale ?
                (
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'isToConsiderClockInDelay'}
                          checked={this.state.flexScaleHours}
                          onChange={event => this.setState({ flexScaleHours: event.target.checked })}
                        />
                      }
                      label={<Typography noWrap>Considerar apenas horas trabalhadas</Typography>}
                    />
                  </Grid>
                ) : ''
            }
            < DialogContentText >


            </DialogContentText>
            <Grid container spacing={2}>
              {
                this.props.values.isZeroScale == false && suportSchudeleConfig == true ?
                  <IconButton onClick={() => this.setState({ openModalBankHours: true })}>
                    <Settings />
                    <Typography variant="button">Configurações de escala</Typography>
                  </IconButton> : ''
              }
              <Dialog open={this.state.tolerance} onClose={() => this.closeToleranceModal()} scroll='body'>
                <DialogTitle style={{ textAlign: 'center' }}>Editar Tolerância</DialogTitle>
                <DialogContent style={{ overflow: 'hidden' }}>
                  <div style={{ width: '600px', marginLeft: '3px' }}>
                    <Grid container justifyContent="center">
                      {toleranceConfig.map(field => (
                        <Grid item key={field.config.name} xs={6}>
                          <Input
                            {...field.config}
                            elementType={field.elementType}
                            value={this.state[field.config.name]}
                            onChange={event => this.handleChangeInput(event, field.config.name)}
                            label={<Typography variant="caption" style={{ fontSize: '12px' }} noWrap>{field.config.label}</Typography>}
                            style={{ width: '250px' }}
                          />
                        </Grid>
                      ))}

                      {toleranceConfigSecondTurn.map(field => (
                        <Grid item key={field.config.name} xs={6}>
                          <Input
                            {...field.config}
                            elementType={field.elementType}
                            value={this.state[field.config.name]}
                            onChange={event => this.handleChangeInput(event, field.config.name)}
                            label={<Typography variant="caption" style={{ fontSize: '12px' }} noWrap>{field.config.label}</Typography>}
                            style={{ width: '250px' }}
                          />
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                </DialogContent>

                <DialogActions justifyContent="center">
                  <Button onClick={() => this.resetTolerance()}>CANCELAR</Button>
                  {/* <Button variant="contained" onClick={() => this.closeToleranceModal()} color="primary" type="submit" autoFocus disabled={this.state.disabledButton}> */}
                  <Button variant="contained" onClick={() => this.closeToleranceModal()} color="primary" type="submit" autoFocus >
                    CONFIRMAR
                  </Button>
                </DialogActions>
              </Dialog>


              {/* modal configuração de banco de horas */}
              <Dialog open={this.state.openModalBankHours} onClose={this.handleCloseModal} style={{ overflowX: 'auto' }} scroll='body'>
                <DialogTitle>Configurações de escala</DialogTitle>
                <DialogContent>
                  {/* <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'tolerance'}
                          checked={this.state.tolerance}
                          onChange={event => this.handleIsTolerance(event)}
                        />
                      }
                      label={<Typography noWrap>Tolerância</Typography>}
                    />
                  </Grid> */}
                  <Grid item xs={12} sm={4}>
                    <Button variant="contained" onClick={() => this.setState({ tolerance: true })} color="primary" size="small" style={{ 'width': '230px' }}>
                      Configurar Tolerância
                    </Button>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'isToConsiderClockInDelay'}
                          checked={this.state.isToConsiderClockInDelay}
                          onChange={event => this.setState({ isToConsiderClockInDelay: event.target.checked })}
                        />
                      }
                      label={<Typography noWrap>Tolerância na intrajornada</Typography>}
                    />
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'considerNightHoursCorrectedInBankHour'}
                          checked={this.state.considerNightHoursCorrectedInBankHour}
                          onChange={event => this.setState({ considerNightHoursCorrectedInBankHour: event.target.checked })}
                        />
                      }
                      label={
                        <Typography noWrap>
                          Conversão da hora noturna
                        </Typography>
                      }
                    ></FormControlLabel>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'hasBankHourLimit'}
                          checked={this.state.hasBankHourLimit}
                          onChange={event => this.setState({ hasBankHourLimit: event.target.checked })}
                        />
                      }
                      label={
                        <Typography noWrap>
                          Limite de horas excedentes
                        </Typography>
                      }
                    ></FormControlLabel>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'specialHoursSundayAndHoliday'}
                          checked={this.state.specialHoursSundayAndHoliday}
                          onChange={event => this.setState({ specialHoursSundayAndHoliday: event.target.checked })}
                        />
                      }
                      label={
                        <Typography noWrap>
                          Considerar hora extra especial aos domingos e feriados
                        </Typography>
                      }
                    ></FormControlLabel>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'considerRemainingHoursToBankHoursAndExtraHours'}
                          checked={this.state.considerRemainingHoursToBankHoursAndExtraHours}
                          onChange={event => this.setState({ considerRemainingHoursToBankHoursAndExtraHours: event.target.checked })}
                        />
                      }
                      label={
                        <Typography noWrap>
                          Política de Jornada de Trabalho sem Compensação Diária conforme CLT
                        </Typography>
                      }
                    ></FormControlLabel>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'isToFollowNormally'}
                          checked={this.state.isToFollowNormally}
                          onChange={event => this.setState({ isToFollowNormally: event.target.checked })}
                        />
                      }
                      label={
                        <Typography noWrap>
                          Considerar feriado como dia normal
                        </Typography>
                      }
                    ></FormControlLabel>
                  </Grid>
                  <Grid item xs={12} sm={4}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          name={'specialExtraHoursInBankHours'}
                          checked={this.state.specialExtraHoursInBankHours}
                          onChange={event => this.setState({ specialExtraHoursInBankHours: event.target.checked })}
                        />
                      }
                      label={
                        <Typography noWrap>
                          Calcular Como Hora extra especial quando há banco de horas
                        </Typography>
                      }
                    ></FormControlLabel>
                  </Grid>


                  {maxAccumulatedPositiveTolerance.map(field => (
                    <Grid item key={field.config.name}>
                      <Input
                        {...field.config}
                        elementType={field.elementType}
                        value={shiftsTurns[field.config.name]}
                        onChange={this.handleInputChange(field.config.name)}
                        label={<Typography variant="caption" style={{ fontSize: '14px' }} noWrap>{field.config.label}</Typography>}
                        style={{ width: '350px' }}
                      />
                    </Grid>
                  ))}
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.handleCloseModal} color="primary">
                    Confirmar
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
            {currentAction === 'Cadastrar' ? (
              <React.Fragment>
                <Grid container className={classes.days}>
                  {days.map((day, index) => (
                    <Grid item xs={6} sm={4} md key={index}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            color="primary"
                            name={day.value}
                            checked={day.checked}
                            onChange={this.handleWeekdaysChange(index)}
                          />
                        }
                        label={day.label}
                      />
                    </Grid>
                  ))}
                </Grid>
                <ShiftForm
                  values={shiftsTurns}
                  handleChange={this.handleInputChange}
                  isZeroScale={this.props.values.isZeroScale}
                  maximumHours={this.setState}
                  isTolerance={this.state.tolerance}
                  flexScaleHours={this.state.flexScaleHours}
                />
              </React.Fragment>
            ) : null}
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose}>CANCELAR</Button>
            {this.props.values.isZeroScale ?
              <Button
                onClick={this.handleConfirm}
                variant="contained"
                color="primary"
              // disabled={currentAction === 'Cadastrar' && this.isDisabled()}
              >
                CONFIRMAR
              </Button>
              :
              <Button
                onClick={this.handleConfirm}
                variant="contained"
                color="primary"
                disabled={currentAction === 'Cadastrar' && this.isDisabled()}
              >
                CONFIRMAR
              </Button>
            }
          </DialogActions>
        </Dialog>
      </React.Fragment >
    );
  }
}

export default withStyles(styles)(WeekdayForm);
